import { Moment } from 'moment'

import ClientSDK from '../../../App/ClientSDK'

import {
  IAPIOccupancyRateReport,
  IOccupancyRateReport,
} from './IOccupancyRateReport'
import Transformer from './Transformer'

export class Client {
  static getOccupancyReport = async (
    from: Moment,
    to: Moment,
  ): Promise<IOccupancyRateReport[]> => {
    const startAt = from.format('YYYY-MM-DD')
    const endsAt = to.format('YYYY-MM-DD')

    const response =
      await ClientSDK.instance().get<IAPIOccupancyRateReport>(
        `report/person-occupancy/${startAt}/${endsAt}`,
      )

    return Transformer.transform(response.data)
  }
}
